export const FONT_SIZE_12 = '12px';
export const FONT_SIZE_14 = '14px';
export const FONT_SIZE_16 = '16px';
export const FONT_SIZE_20 = '20px';
